<template>
    <div>
        <mensajeSistema></mensajeSistema>

        <v-tabs v-model="tabs" dark dense class="rounded-lg" background-color="primary" active-class="tab-active"
            slider-color="#ffbc00">
            <v-tab> Crear Normativa Ministerial </v-tab>
            <v-tab> Asociar condiconales a las normativas </v-tab>
        </v-tabs>

        <v-tabs-items touchless v-model="tabs">
            <v-tab-item class="py-4 ml-4">
                <CrearNormativas :normativas_ministeriales='normativas_ministeriales'/>
            </v-tab-item>

            <v-tab-item class="py-4 ml-4">
                <AsociarNormativas :normativas_ministeriales='normativas_ministeriales'/>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import axios from "../../../helpers/axios";
import CrearNormativas from './components/CrearNormativaMinisterial.vue';
import AsociarNormativas from './components/AsociarCondiciones.vue';
import { mapMutations } from "vuex";

export default {
    components: {
        CrearNormativas,
        AsociarNormativas
    },

    data:() =>  ({
        tabs: 0,
        normativas_ministeriales: []
    }),
    mounted(){
        this.getNormativas();
    },

    methods: {
        /*________________________
        |   PETICIONES AL BACK  */
        async getNormativas() {
            try {
                const response = await axios.get('/cierreanio/cierreanioituacionestudiante/normativas');

                this.normativas_ministeriales = response.data.normativas;

                console.log('greyci', response.data.normativas);


            } catch (error) {
                console.log(error.message);
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al intentar traer las normativas.',
                    tiempo: 5000,
                });
            }
        },
    },
    

    /*_______________
    |   MUTATIONS  */
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

}

</script>